import * as Constants from "../common/Constants";

const initialState = {
    roles: [],
    myRoles: [],
    role:null,
    filteredRoles: [],
    userRoles: [],
    isLoading: false,
    isPosting: false,
    isPosted: false,
    count: 0,
    page: 1,
    pageSize: 20,
    error: null
};

export default function roleReducer(state = initialState, action) {

    var newState;

    switch (action.type) {
        
        case Constants.REQUEST_ADD_ROLE:
            
            newState = { ...state };
            newState.isPosting = true;
            newState.isPosted = false;
            newState.error = null;
            return newState;
        case Constants.SUCCESS_ADD_ROLE:
            
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = true;
            newState.error = null;
            newState.role = action.role;
            return newState;
        case Constants.FAILED_ADD_ROLE:
            
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = action.error;
            return newState;


        case Constants.REQUEST_GET_ROLE:
        case Constants.REQUEST_GET_MY_ROLE:
            newState = { ...state };
            newState.isLoading = true;
            newState.isPosted = false;
            newState.error = null;
            return newState;

        case Constants.SUCCESS_GET_ROLE:
            
            newState = { ...state };
            newState.isLoading = false;
            newState.error = null;
            if (action.userId > 0) {
                newState.userRoles = action.payload;
            }
            else if (Array.isArray(action.payload)) {
                
                newState.roles = action.payload;
            } else {
                
                newState.role = action.payload;
            }
            return newState;

        case Constants.SUCCESS_GET_MY_ROLE:
            
            newState = { ...state };
            newState.isLoading = false;
            newState.error = null;
            newState.myRoles = action.payload;
            return newState;

        case Constants.FAILED_GET_ROLE:
        case Constants.FAILED_GET_MY_ROLE:
            
            newState = { ...state };
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/RoleReducer.js